module.exports = __webpack_public_path__ + "static/media/subscribe-card.c2d90562.jpg";